import { create } from 'zustand';

interface EditChecklistStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useEditChecklistModal = create<EditChecklistStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useEditChecklistModal;
